import React, { useEffect, useState } from "react";
import { api, ApiError, type Property } from "../../api";
import { useToast } from "../../ToastContext";
import { useLanguage } from "../../i18n";

// When the ToLetBook team added a property for the owner, its map pin was
// placed from a map or a shared link, so it is only approximate. This asks the
// owner to confirm it with GPS while they are at the property.
export function ConfirmLocationNotice() {
  const { t } = useLanguage();
  const toast = useToast();
  const [props, setProps] = useState<Property[]>([]);
  const [busyId, setBusyId] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    api
      .get("/api/properties/mine")
      .then((d) => live && setProps((d.properties as Property[]).filter((p) => p.locationApproximate)))
      .catch(() => { });
    return () => { live = false; };
  }, []);

  function confirm(p: Property) {
    if (!navigator.geolocation) {
      toast(t("confirmLocation.noGps"));
      return;
    }
    setBusyId(p.id);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          await api.post(`/api/properties/${p.id}/confirm-location`, { lat: pos.coords.latitude, lng: pos.coords.longitude });
          toast(t("confirmLocation.doneToast"));
          setProps((cur) => cur.filter((x) => x.id !== p.id));
        } catch (err) {
          toast(err instanceof ApiError ? err.message : t("common.somethingWrong"));
        } finally {
          setBusyId(null);
        }
      },
      () => {
        setBusyId(null);
        toast(t("confirmLocation.denied"));
      },
      { enableHighAccuracy: true, timeout: 15000 }
    );
  }

  if (props.length === 0) return null;
  const p = props[0];
  return (
    <div className="card" style={{ marginBottom: 14, borderColor: "var(--cash)" }}>
      <b style={{ fontSize: 13 }}>{t("confirmLocation.title", { name: p.label })}</b>
      <div className="sub" style={{ fontSize: 12, margin: "2px 0 10px" }}>{t("confirmLocation.body")}</div>
      <button className="btn-solid btn-sm" disabled={busyId === p.id} onClick={() => confirm(p)}>
        {busyId === p.id ? t("confirmLocation.working") : t("confirmLocation.btn")}
      </button>
    </div>
  );
}
